export default "__VITE_ASSET__B4Jzj47P__"